module.exports = __webpack_public_path__ + "images/img-vUfV0Zr.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/month.jpg
// module id = 2000
// module chunks = 0